var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "89", height: "37", viewBox: "0 0 89 37", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "delivery-truck-outline-icon"
    ),
    React.createElement(
      "g",
      { transform: "translate(1)", fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M80.5 16.5l-.5.5v-1l.5.5zm0 0l.5.5H68l.5-.5-.5-.5h13l-.5.5zm-12 0l.5.5v-1l-.5.5zM68 16h13v1H68v-1zm-.5.5l-.5.5V6l.5.5.5-.5v11l-.5-.5zm0 0l.5-.5h-1l.5.5zM68 7l-.5-.5-.5.5h1zm0-1v11h-1V6h1z", fill: "#222", fillRule: "nonzero" }),
      React.createElement("path", { stroke: "#222", d: "M20.5.5h42v30h-42zm67 30h-25V8.004A1.5 1.5 0 0 1 64.003 6.5h8.994c.931 0 2.126.676 2.606 1.476l4.968 8.281.146.243H81c3.577 0 6.5 3.34 6.5 7.505V30.5z" }),
      React.createElement("circle", { stroke: "#222", fill: "#F7F7F7", cx: "36", cy: "30", r: "6" }),
      React.createElement("circle", { stroke: "#222", fill: "#F7F7F7", cx: "76", cy: "30", r: "6" }),
      React.createElement("path", { d: "M25 36h19.252M9 15h15m-8 9h20M0 7h30m25 29h5m3 0h19.252", stroke: "#222", strokeLinecap: "round", strokeLinejoin: "round" })
    )
  );
});


// WEBPACK FOOTER //
// ../public/images/icons/delivery-truck-outline.svg?react-svg